import FeedInfoModal from './FeedInfoModal';

export default FeedInfoModal;
